// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FulfillmentMethod } from "@ces/XDL/types";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod"



const XPopulateApiParameter : typeof PopulateApiParameter = (props) => {
    const  updatedFulfillmentMethod = props.apiParameter.session.fulfillmentMethod;
    let fulfillmentMethod = updatedFulfillmentMethod;
    if(updatedFulfillmentMethod !== FulfillmentMethod.Ship) {
        fulfillmentMethod = FulfillmentMethod.Pickup;
    }
    props.apiParameter.session.fulfillmentMethod = fulfillmentMethod
    props.apiParameter.session.properties = {
        ...(props.apiParameter.session.properties || {}),
        ...(updatedFulfillmentMethod !== FulfillmentMethod.Ship && {
            pickUpType: updatedFulfillmentMethod,
        }),
    }
}


addToChainAfter(chain, PopulateApiParameter, XPopulateApiParameter)
